import { render, staticRenderFns } from "./projectSetting.vue?vue&type=template&id=4dec6b66&scoped=true&"
import script from "./projectSetting.vue?vue&type=script&lang=js&"
export * from "./projectSetting.vue?vue&type=script&lang=js&"
import style0 from "./projectSetting.vue?vue&type=style&index=0&id=4dec6b66&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dec6b66",
  null
  
)

export default component.exports